<template>
  <div class="status-wrap">
    <div class="whitespace-pre text-center mb-3">{{ congratsText }}</div>
    <div class="whitespace-pre text-center text-xs font-light mb-4">{{ congratsDes }}</div>
    <img
      width="200"
      class="mb-20"
      src="../../../assets/Purchase/payment_succeed.svg"
      :alt="$t('mobileScan.begin_info')"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckoutConfirm',
  props: {
    show: Boolean,
  },
  computed: {
    congratsText() {
      return this.$t('mobileScan.payment_succeed');
    },
    congratsDes() {
      return this.$t('mobileScan.payment_succeed_des');
    },
  },
};
</script>

<style lang="scss" scoped>
.status-wrap {
  @apply w-full flex flex-col items-center justify-center flex-grow;
}
</style>
